import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminEmployeeList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import EmployeeListLayout from "../../layouts/Admin/EmployeeListLayout";

const AdminEmployeeList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <EmployeeListLayout />
    </>
  );
};

export default AdminEmployeeList;
